import { ChangeDetectionStrategy, Component, Input, HostListener, ChangeDetectorRef, inject } from '@angular/core';
import { MediaImage, ImageData, MediaVideo, Image, IMediaItem, ImageItemComponent, PlayButtonComponent, ButtonComponent, MediaSliderComponent, MediaCollectionModalComponent } from '@sirius/common';
import { ProductImageThumbnailsComponent } from '../product-image-thumbnails/product-image-thumbnails.component';

@Component({
    selector: 'commerce-product-image-slider',
    templateUrl: './product-image-slider.component.html',
    styleUrls: ['./product-image-slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ImageItemComponent, PlayButtonComponent, ButtonComponent, MediaSliderComponent, ProductImageThumbnailsComponent, MediaCollectionModalComponent]
})
export class ProductImageSliderComponent {
    private cdr = inject(ChangeDetectorRef);

    @Input() mediaItems: IMediaItem[] = [];
    @Input() imageData?: ImageData;

    currentIndex = 0;
    showDescription = false;
    open = false;


    @HostListener('window:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent): void {
        switch (event.key) {
            case 'ArrowLeft':
                this.previous();
                break;
            case 'ArrowRight':
                this.next();
                break;
        }
    }

    getThumbnailMediaItem(item: IMediaItem): MediaImage | null {
        if (item.type === 'video') {
            const videoItem = item as MediaVideo;
            if (videoItem.thumbnail) {
                const thumbnailImage = new Image(videoItem.thumbnail.url, videoItem.thumbnail.source);
                return new MediaImage(thumbnailImage, videoItem.title);
            }
            return null;
        }
        return item as MediaImage;
    }

    setCurrentIndex(index: number): void {
        if (index >= 0 && index < this.mediaItems.length) {
            this.currentIndex = index;
            this.cdr.detectChanges();
        }
    }

    previous(): void {
        if (this.currentIndex > 0) {
            this.setCurrentIndex(this.currentIndex - 1);
        }
    }

    next(): void {
        if (this.currentIndex < this.mediaItems.length - 1) {
            this.setCurrentIndex(this.currentIndex + 1);
        }
    }

    openModal(): void {
        this.open = true;
        this.cdr.detectChanges();
    }

    onClose(): void {
        this.open = false;
        this.cdr.detectChanges();
    }
}
